<template>
    <div id="content">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"></popup>
        <div class="inner">
            <add-button v-if="$_createActionAllowed" :title="'Přidat typ zařízení' | translate" route-name="deviceTypeNew"></add-button>
            <h1 v-translate>Typy zařízení</h1>
        </div>
      <div class="inner_white">
        <div class="filter">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
             :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>

        <div class="scroll-wrapper">
          <div class="table_overflow" id="contentBox" data-table-id="device-types-list">
            <table class="vypis vypis_detail">
              <thead>
              <tr v-if="entities.length > 0">
                <th class="no_padding drag_drop"></th>
                <th class="no_padding checkbox"/>
                <sorting-table-title
                    v-for="title in deviceTypesTableTitles"
                    :key="title.key"
                    :column="title.column"
                    :sort="getActiveSort(title.column)"
                    @changeSorting="changeSorting"
                >{{ title.name }}
                </sorting-table-title>
                <th class="no_padding edit"></th>
              </tr>
              </thead>

              <device-type-row
                  v-for="entity in entities"
                  :entity="entity"
                  :key="entity.id"
                  :selectedEntities="selectedEntities"
                  @input="select"
                  @deleteDeviceType="deleteEntity"
                  :ref="'device-type-row-ref-'+entity.id"
              ></device-type-row>
              <tr v-if="entities.length === 0">
                   <td colspan="8">{{ $gettext('Nebyly nalezeny žádné typy zařízení.') }}</td>
              </tr>
            </table>
          </div>
        </div>
        <list-action-line
            :entities="entities"
            :offset="formFields.offset"
            :limit="formFields.limit"
            :total-count="totalCount"
            :selected-entities="selectedEntities"
            :multiple-action-options="multipleActionOptions"
            table-id="device-types-list"
            @select-all="toggleSelectAll"
            @run-multiple-action="runMultipleAction"
            @limit="setLimit"
            @offset="setOffset"
            ref="action_line"
        ></list-action-line>
      </div>
    </div>
</template>

<script>
import DeviceTypeRow from "@/components/views/deviceTypes/DeviceTypeRow"
import listActions from "@/components/mixins/list-actions"

export default {
    name: "DeviceTypes",
    components: {
        DeviceTypeRow,
    },
    mixins: [listActions],
    data() {
        return {
            moduleName: 'deviceTypes',
            formFields: {
                sort: {
                    column: 'sName',
                    direction: 'asc',
                }
            }
        }
    },
    created(DeviceTypeService) {
        this.entityService = DeviceTypeService
        this.createdInit()
    },
    computed: {
        deviceTypesTableTitles() {
            return [
                {key: 1, name: this.$gettext('Název'), column: 'sName'},
                {key: 2, name: this.$gettext('Kód'), column: 'sCode'},
                {key: 3, name: this.$gettext('Skupina zařízení'), column: 'sDeviceGroupName'},
                {key: 4, name: this.$gettext('Extra tracky'), column: 'sAllowExtraTracks', sortable: false},
                {key: 5, name: this.$gettext('Počet zařízení'), column: 'sDeviceCount'},
                {key: 6, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
                {key: 7, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
            ]
        },
      multipleActionOptions() {
        return [
          {value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        ]
      },
      csvHeaders(){
       let headers = this.getCsvHeaderFromSortingTableTitle(this.deviceTypesTableTitles);
       headers.device_group_name.callback = entity=> { return entity.name_device_group};
       headers.allow_extra_tracks.callback = entity => { return entity.allow_extra_tracks ? this.$gettext('Ano') : this.$gettext('Ne')};

       return headers;
      },
    },
    methods: {
        _processListErrorMessage(error) {
            let errorMessage = null;

            this._.forEach(error['validation_errors'], function (message) {
                errorMessage = message;
            }.bind(this))

            return errorMessage || error['error_message'];
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceTypes/DeviceTypesList.vue